import Vue from 'vue'

const pluginsContext = require.context('./', true, /\.js$/)

pluginsContext.keys().forEach(plugin => {
  const pluginConf = pluginsContext(plugin)
  if (plugin.startsWith('./index')) {
    return null
  }
  /**
   * 兼容 import export 和 require module.export 两种规范
   */
  Vue.use(pluginConf.default || pluginConf)
})
